/* 公共引入,勿随意修改,修改时需经过确认 */
import Vue from "vue";
// 引入自定义指令
import directive from "./directive";
Vue.use(directive);



// WEBPACK FOOTER //
// ./src/plugins/index.js